<template>
  <div class="list-attendance" v-if="classData && classData.id">
    <div class="pa-5 pb-0 d-flex justify-space-between">
      <div class="header-title">
        {{ `Lớp ${classData.title || ''}` }}
      </div>
    </div>
    <div v-if="!lessons.length">
      <v-card class="d-flex flex-column align-center justify-center elevation-0 ma-4 mb-0 pa-6" outlined>
        <img :src="TimeTableImage" alt="student-setting" />
        <span class="mt-4"> Lớp này chưa được xếp lịch học, vui lòng cài đặt thời khóa biểu </span>
        <v-btn
          elevation="0"
          color="primary"
          class="mt-4"
          @click="() => $refs['popup-new-class-time-table'].openDialog()"
        >
          <v-icon left>mdi-plus</v-icon>
          Cài đặt thời khóa biểu
        </v-btn>
      </v-card>
    </div>
    <div class="list-attendance__wrapper">
      <div v-for="(item, index) in lessons" :key="index">
        <div class="list-attendance__wrapper--item">
          <LessonCard
            :data="item"
            :isNearest="nearestSessionId === item.id"
            @onSelectClass="() => onSelectClass(item)"
          />
        </div>
      </div>
    </div>
    <PopupAttendance ref="popup-attendance" @refresh="refresh" />
    <PopupNewClassTimeTable @refresh="refresh" ref="popup-new-class-time-table" />
  </div>
  <v-card v-else class="d-flex flex-column align-center justify-center elevation-0 ma-4 mb-0 pa-6" outlined>
    <img :src="TimeTableImage" alt="student-setting" />
    <span class="mt-4">
      Vui lòng cung cấp các thông tin ở trên, sau đó ấn [ Chọn xem ] để xem danh sách điểm danh theo buổi học
    </span>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import LessonCard from './components/LessonCard.vue'
import PopupAttendance from './components/PopupAttendance.vue'
import TimeTableImage from '@/assets/time-table-default.svg'
import PopupNewClassTimeTable from '@/views/timetable/components/PopupNewClassTimeTable.vue'
import dayjs from 'dayjs'

export default {
  components: { LessonCard, PopupAttendance, PopupNewClassTimeTable },
  computed: {
    ...mapState({
      lessons(state) {
        return state['lesson'].lessons
      },
      classData(state) {
        return state['class'].clazz
      },
    }),
  },
  data() {
    return {
      sessions: [],
      nearestSessionId: '',
      TimeTableImage,
    }
  },
  created() {
    this.setLessons([])
  },
  methods: {
    ...mapActions({
      fetchSessions: 'lesson/fetchLessons',
    }),
    ...mapMutations({
      setLessons: 'lesson/setLessons',
    }),
    async refresh() {
      await this.fetchSessions({
        class: this.classData.id,
        _sort: { date: -1 },
        date_lte: dayjs().endOf('day').toISOString(),
      })
    },
    async onSelectClass(item) {
      await this.$refs['popup-attendance'].openPopup({
        title: `buổi ${item.index}`,
        date: item.date,
        id: item.id,
        isAttended: item.isAttended,
        classData: item,
      })
    },
  },
  watch: {},
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-application .justify-space-between {
    justify-content: end !important;
  }
}
.list-attendance {
  width: 100%;
  height: auto;
  &__title {
    width: 100%;
    padding: 24px 0 24px 24px;
  }
  &__wrapper {
    padding: 18px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 12px;
    &--item {
      height: 100%;
      width: 100%;
    }
  }
}
.header-title {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
}
</style>
